import { render, staticRenderFns } from "./vImportCustomIngredientsModal.vue?vue&type=template&id=6e4fb64a"
import script from "./vImportCustomIngredientsModal.vue?vue&type=script&lang=ts"
export * from "./vImportCustomIngredientsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports